import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";

export default function SiteLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#f6f8fa] text-[#0f1f2c]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
